import * as React from 'react';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import UserService from '../../../services/userService';
import Translate from '../../../common/functions/translate';
import { AcceptanceType } from "../../../common/enums";
import { enumToDropdownArray, fomatDateTimeAsString, getEnumLabel } from '../../../common/functions/helperFunctions';
import { DropdownModel } from "../../../models/dropdownModel";
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import Spinner from '../../../common/components/spinner/spinner';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Growl from '../../../common/components/alertMessage/growl';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { faCheck, faTimes, faClock } from '@fortawesome/free-solid-svg-icons';
import blue from '@material-ui/core/colors/blue';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import * as Constants from '../../../common/constants';

interface IProps {
  isVisible: boolean,
  handleCancelButton: any,
  handleSaveButton: any,
  notifiicationSchedulerId: number
}

interface IState {
  isLoading: boolean;
  selectedAcceptanceType: number;
  acceptanceType: Array<DropdownModel>;
  takenAt: string;
  isTaken: boolean;
  isSnoozed: boolean;
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '50% !important',
        minWidth: '335px'
      }
    }
  },
  palette: {
    primary: blue
  },
});

class UserNotificationAcceptance extends React.Component<IProps, IState> {
  userService = new UserService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      selectedAcceptanceType: 1,
      acceptanceType: new Array<DropdownModel>(0),
      takenAt: '',
      isTaken: false,
      isSnoozed: false,
    }
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
      acceptanceType: enumToDropdownArray(AcceptanceType, true)
    });
    this.userService.getNotificationScheduler(this.props.notifiicationSchedulerId).then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false,
            selectedAcceptanceType: data.takeTypeId ? data.takeTypeId : 1,
            takenAt: data.takenAt ? data.takenAt : fomatDateTimeAsString(new Date()),
            isTaken: data.takenAt ? true : false,
            isSnoozed: data.isSnoozed === true ? true : false
          });
        }
      })
      .catch(error => {
        this.setState({
          isLoading: false
        });
        this.growl.show({ severity: 'error', summary: error.message });
      });

  }

  handleDropdownChange = (acceptance) => {
    this.setState({ selectedAcceptanceType: acceptance });
  }

  handleDateChange = (value) => {
    this.setState({ takenAt: value })
  }

  handleSave = () => {
    if (!this.state.takenAt) {
      this.setState({ takenAt: new Date().toUTCString() });
    }
    this.setState({ takenAt: new Date(this.state.takenAt).toUTCString() }, this.saveTaken);
  }

  handleSnooze = () => {
    if (!this.state.takenAt) {
      this.setState({ takenAt: new Date().toUTCString() });
    }
    //this.setState({ takenAt: new Date(this.state.takenAt).toUTCString() });
    this.setState({ takenAt: new Date(this.state.takenAt).toUTCString() }, this.saveSnoozed);
  }

  saveTaken = () => {
    this.setState({
      isLoading: true
    });

    this.userService.setTakenNotification(this.props.notifiicationSchedulerId, this.state.selectedAcceptanceType, this.state.takenAt).then(
      (data: any) => {
        if (data) {
          this.props.handleCancelButton();
        }
      })
      .catch(error => {
        this.setState({
          isLoading: false
        });
        this.growl.show({ severity: 'error', summary: error.message });
      });
  }

  saveSnoozed = () => {
    this.setState({
      isLoading: true
    });

    this.userService.setSnoozedNotification(this.props.notifiicationSchedulerId, Constants.SnoozeMinutes, this.state.takenAt).then(
      (data: any) => {
        if (data) {
          this.props.handleCancelButton();
        }
      })
      .catch(error => {
        this.setState({
          isLoading: false
        });
        this.growl.show({ severity: 'error', summary: error.message });
      });
  }

  handleSliderChange = (e, value) => {
    e.preventDefault();
    this.setState({ selectedAcceptanceType: value });
  };

  render() {
    const { selectedAcceptanceType, acceptanceType, takenAt, isLoading, isTaken, isSnoozed } = this.state;
    let buttonFontsize = window.innerWidth < Constants.device.tablet ? 12 : 'unset';
    return (
      <>
        <MuiThemeProvider theme={theme}>
          <Dialog
            open={this.props.isVisible}
            onClose={this.props.handleCancelButton}
            fullWidth
          >
            <Modal.DialogTitle id="customized-dialog-title" onClose={this.props.handleCancelButton}>{Translate('Specification of intake')}
            </Modal.DialogTitle>

            <Modal.DialogContent>
              <Growl ref={(el) => this.growl = el} />
              {isLoading ? <Spinner /> : null}
              <div style={{ width: '100%', marginBottom: 15 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DateTimePicker
                    autoOk
                    ampm={false}
                    disableFuture
                    format={Translate('DateTimeFormat')}
                    margin="normal"
                    label={Translate('Date')}
                    value={takenAt ? new Date(takenAt) : new Date()}
                    onChange={(e) => this.handleDateChange(e)}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div style={{ width: '100%', marginBottom: 10 }}>
                <FormControl>
                  <InputLabel htmlFor="condition-type-label">{Translate('Choose acceptance')}</InputLabel>
                  <Select
                    value={selectedAcceptanceType}
                    onChange={(e) => this.handleDropdownChange(e.target.value)}
                    inputProps={{
                      id: 'condition-type-label'
                    }}>
                    {acceptanceType.map(m => <MenuItem key={m.value + 'condTypeItem'}
                      value={m.value}>{m.value ? m.label : <em>{m.label}</em>}</MenuItem>)}
                  </Select>
                </FormControl>
              </div>
            </Modal.DialogContent>

            <Modal.DialogActions>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }} >
                <div>
                  <Button variant="contained" size="small" onClick={this.handleSnooze} color="primary" style={{ marginRight: '5px' }}
                    disabled={isTaken === true || isSnoozed === true ? true : false}>
                    <FontAwesomeIcon icon={faClock} style={{ marginRight: '4px' }} />
                    <span style={{ fontSize: buttonFontsize }}>{Translate('Snooze')}{" (" + Constants.SnoozeMinutes + " " + Translate('min.') + ")"}</span>
                  </Button>
                </div>
                <div >
                  <Button variant="contained" size="small" onClick={this.props.handleCancelButton} style={{ marginRight: '5px' }}>
                    <FontAwesomeIcon icon={faTimes} style={{ marginRight: '4px' }} />
                    <span style={{ fontSize: buttonFontsize }}>{Translate('Cancel')}</span>
                  </Button>
                  <Button variant="contained" size="small" color="primary" onClick={this.handleSave} >
                    <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />
                    <span style={{ fontSize: buttonFontsize }}>{Translate('Take')}</span>
                  </Button>
                </div>
              </div>
            </Modal.DialogActions>

          </Dialog>
        </MuiThemeProvider>
      </>
    )
  }
}

export default UserNotificationAcceptance;
